import { render, staticRenderFns } from "./VideoDisplay.vue?vue&type=template&id=4ed1fb2a&scoped=true&lang=html&"
import script from "./VideoDisplay.vue?vue&type=script&lang=js&"
export * from "./VideoDisplay.vue?vue&type=script&lang=js&"
import style0 from "./VideoDisplay.vue?vue&type=style&index=0&id=4ed1fb2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed1fb2a",
  null
  
)

export default component.exports